import queryString from 'query-string'
import { ScheduleAPI } from './types'

export const scheduleApi: ScheduleAPI = ky => {
  return {
    async schedule({ month }) {
      return await ky('schedule/', {
        method: 'get',
        searchParams: queryString.stringify({ month })
      }).json()
    },

    async calendar({ month, year, patientId }) {
      return await ky('schedule/calendar/', {
        method: 'get',
        searchParams: queryString.stringify({
          month,
          year,
          // eslint-disable-next-line @typescript-eslint/camelcase
          patient_id: patientId
        })
      }).json()
    },

    async create({ params }) {
      return await ky(`schedule/`, {
        method: 'post',
        json: params
      }).json()
    },

    async replace({ params, scheduleId }) {
      return await ky(`schedule/${scheduleId}/`, {
        method: 'put',
        json: params
      }).json()
    },

    async update({ params, scheduleId }) {
      return await ky(`schedule/${scheduleId}/`, {
        method: 'patch',
        json: params
      }).json()
    },

    async fetch({ scheduleId }) {
      return await ky(`schedule/${scheduleId}/`, {
        method: 'get'
      }).json()
    },

    async delete({ scheduleId }) {
      await ky(`schedule/${scheduleId}/`, {
        method: 'delete'
      })
    }
  }
}
